import { useTheme } from '@mui/material/styles';

// Theme-aware replacement for the old static Colors export. The previous
// version hardcoded dark-theme hex values directly, so every one of its ~80
// call sites stayed dark-themed even when the user switched to light or
// Oasis. useColors() reads the currently active theme instead, so the same
// Colors.backgroundDark1 / Colors.mainYellow call sites now actually change
// with the theme.
export const useColors = () => {
  const theme = useTheme();
  return {
    backgroundGray: theme.palette.background.elevated,
    backgroundDark1: theme.palette.background.paper,
    backgroundDark2: theme.palette.background.default,
    backgroundDark3: theme.palette.background.elevated,
    mainYellow: theme.palette.primary.main,
    primary: theme.palette.primary.main,
    primaryDark: theme.palette.primary.dark,
  };
};
